import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import zhCommon from './locales/zh-TW/common.json';
import zhConsult from './locales/zh-TW/consult.json';
import zhClinic from './locales/zh-TW/clinic.json';
import zhEdu from './locales/zh-TW/edu.json';
import enCommon from './locales/en/common.json';
import enConsult from './locales/en/consult.json';
import enClinic from './locales/en/clinic.json';
import enEdu from './locales/en/edu.json';
import viCommon from './locales/vi/common.json';
import viConsult from './locales/vi/consult.json';
import viClinic from './locales/vi/clinic.json';
import viEdu from './locales/vi/edu.json';
import idCommon from './locales/id/common.json';
import idConsult from './locales/id/consult.json';
import idClinic from './locales/id/clinic.json';
import idEdu from './locales/id/edu.json';

export const SUPPORTED_LANGS = ['zh-TW', 'en', 'vi', 'id'] as const;
export type AppLang = (typeof SUPPORTED_LANGS)[number];

/** localStorage key（兩前端共用同一名稱，但各自獨立記憶） */
export const LANG_STORAGE_KEY = 'klchb_lang';

const resources = {
  'zh-TW': { common: zhCommon, consult: zhConsult, clinic: zhClinic, edu: zhEdu },
  en: { common: enCommon, consult: enConsult, clinic: enClinic, edu: enEdu },
  vi: { common: viCommon, consult: viConsult, clinic: viClinic, edu: viEdu },
  id: { common: idCommon, consult: idConsult, clinic: idClinic, edu: idEdu },
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'zh-TW',
    supportedLngs: SUPPORTED_LANGS as unknown as string[],
    ns: ['common', 'consult', 'clinic', 'edu'],
    defaultNS: 'common',
    interpolation: { escapeValue: false },
    detection: {
      // 僅依 localStorage 記憶；無紀錄時 fallback 到 zh-TW（不依瀏覽器語言，避免誤判）
      order: ['localStorage'],
      lookupLocalStorage: LANG_STORAGE_KEY,
      caches: ['localStorage'],
    },
  });

export default i18n;

/** 取得當前 app 語系（供衛教內容 JSON 依語系載入用），非支援語系一律回 zh-TW */
export function currentContentLang(): AppLang {
  return (SUPPORTED_LANGS as readonly string[]).includes(i18n.language)
    ? (i18n.language as AppLang)
    : 'zh-TW';
}
